import axios from 'axios';
import { IDatabase } from '../../../database';
import { IUserV2 } from '../../../types';
import { FlowyGlobal } from '../../../flowy';
import { gnov, snov } from '../../../utils';

interface IParams {
  context: {
    apiUrl: string;
    user?: IUserV2;
    global?: FlowyGlobal;
    database: IDatabase;
  };
}

/**
 * If locations are saved, upload them to the server
 *
 * @param {string} apiUrl server url
 * @param {IUserV2} user user object
 * @param {IDatabase} database database instance
 */
async function uploadLocations({ context }: IParams) {
  const { apiUrl, database, user, global } = context;

  if (user) {
    const credentials: any = user.credentials;
    const savedLocations = await database.search({
      type: 'locations',
      params: {},
    });
    const locations = savedLocations.slice(0, 100).map(l => l.data);

    if (locations.length > 0 && credentials) {
      const url = `${apiUrl}/main_api/v1/locations/save`;

      try {
        const response = await axios.post(
          url,
          {
            locations,
          },
          {
            headers: {
              ...credentials,
            },
          }
        );

        if (response.status === 200) {
          if (global) {
            const sync = global.getSync();

            if (sync) {
              const total = gnov(sync, 'progressBar.total');
              const progress = gnov(sync, 'progressBar.progress');

              if (progress + locations.length <= total) {
                snov(sync, 'progressBar.progress', progress + locations.length);
                global.setSync(sync);
              }
            }
          }
          for (const location of locations) {
            await database.delete({
              type: 'locations',
              fid: location.fid!,
            });
          }
        }
      } catch (error) {
        console.log('upload.locations.error: ', error);
      }
    }
  }
}

export default uploadLocations;
